import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { CommonService } from './shared/common.service';
import { AuthenticationService } from './commonservice/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription, firstValueFrom } from 'rxjs';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { PermissionService } from './shared/permission.service';
import { AccountsService } from './shared/accounts.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment-timezone';
import { XeroService } from './settings/connections/xero/xero.service';
import { AuthService } from './shared/auth.service';
import { takeUntil, finalize } from 'rxjs/operators';
import { HubConnection, HubConnectionBuilder, LogLevel, HttpTransportType } from '@microsoft/signalr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../environments/environment';
import * as SignalRNotification from './Models/SignalRNotification';
import { ReferenceDataCacheService } from './commonservice/reference-data-cache.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit, OnDestroy {
  public isAuthenticated: boolean;
  public username: string | undefined;
  public userEmail: string | undefined;
  public access_token: string;
  public id_token: string;
  public loginEmail: string;
  title = 'KC identity platform';
  isIframe = false;
  loginDisplay = false;
  currentURl: string;
  preLoader: boolean = false;
  public Email: string;
  public Password: string;
  public InviteAccepted: boolean = false;
  public IsUserDeleted: boolean = false;
  user: any; result: any;
  public b2csignlink: string;
  public b2cChangePassword: string;
  public folderPath: string;
  href: string;
  public currentPath: string;
  public queryParams: { [key: string]: any } = {};
  userdata: any;
  userTimeZoneLocation: any;
  userTimeZone: any;
  unsubscribe = new Subject<void>();
  @ViewChild(SidebarComponent) sidebarComponent!: SidebarComponent;
  @ViewChild('ErrorModalPopup', { static: false }) public ErrorModalPopup: any;
  @ViewChild('SignalRModalPopup', { static: false }) public SignalRModalPopup: any;
  private readonly unsubscribe$ = new Subject<void>();
  private hubConnectionBuilder!: HubConnection;
  dashBoardMessage: boolean = false;
  SignalRTitle: string = "SignalR";
  SignalRActionType: SignalRNotification.SignalRActionTypes = SignalRNotification.SignalRActionTypes.DefaultNone;
  SignalRMessages: string = "";
  modalRef: BsModalRef;
  idleTimeoutModalRef: BsModalRef;
  IsSignalRPopupOpen: boolean = false;
  IsAccountingfirmSwitched: boolean = false;
  IsLocalEnvironment: boolean = true; // Set this based on your environment
  isSystemIdle: boolean = false;
  private hasInitializedAuthenticatedApp: boolean = false;
  public isLoginCompletedSuccessfully: boolean = false;
  public isMsgFromLoginPage: boolean = false;
  public ErrorTitle: string;
  public ErrorMessage: string;
  public IsErrorPopupOpen: boolean = false;
  private signalRModalAutoCloseTimer: ReturnType<typeof setTimeout> | null = null;
  private readonly appLoaderActiveClass = 'kc-app-loader-active';

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private activatedroute: ActivatedRoute,
    private permissionService: PermissionService,
    private commonService: CommonService,
    private accountService: AccountsService, private xeroService: XeroService,
    private _toastr: ToastrService, private authService: AuthService, private modalService: BsModalService,
    private referenceDataCache: ReferenceDataCacheService) {
    this.isAuthenticated = this.authenticationService.isAuthenticated;
    this.isLoginCompletedSuccessfully = false;
    if (this.isAuthenticated) {
      this.username = this.authenticationService.username;
      this.loginEmail = this.authenticationService.userEmail;
      this.access_token = this.authenticationService.userAccessToken;
      localStorage.setItem('Email', this.loginEmail);
      localStorage.setItem('AccessToken', this.access_token);
      localStorage.setItem('IdToken', this.authenticationService.userIdToken);
      localStorage.setItem('RefreshToken', this.authenticationService.userRefreshToken);
      localStorage.setItem('SessionId', this.authenticationService.userSessionID);
      localStorage.setItem('KcUserId', this.authenticationService.userSubject);
      const storageEvent = new Event('storage');
      window.dispatchEvent(storageEvent);
      this.b2cLoginTokenHendler();
    }
    else {
      this.authenticationService.login();
      localStorage.setItem('AccessToken', "");
      localStorage.setItem('IdToken', "");
      localStorage.setItem('RefreshToken', "");
      localStorage.setItem('SessionId', "");
      localStorage.setItem('KcUserId', "");
    }

    this.sub.add(this.commonService.kcLoader.subscribe(res => {
      /* Have used setTimeout to avoid error of "Expression has changed after it was checked" */
      setTimeout(() => {
        const isSuppressed = this.commonService.globalLoaderSuppressed.getValue();
        const show = res && !isSuppressed;
        this.preLoader = show;
        document.body.classList.toggle(this.appLoaderActiveClass, show);
      }, 0);
    }));
  }
  private sub = new Subscription();
  private isNavigationBlocked: boolean = false;

  ngOnInit() {
    this.IsLocalEnvironment = (environment.apiBasePath.includes('localhost') || environment.apiClientPath.includes('localhost')) ? true : false;

    const nav = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming;
    if (nav?.type === "reload") {
      if (localStorage.getItem('AccountingfirmSwitched') === 'true') {
        localStorage.removeItem('AccountingfirmSwitched');
        this.logoutB2C();
        return;
      }
      localStorage.removeItem('AccountingfirmSwitched');
    }
    else {
      // Clear the flag on normal navigation
      localStorage.removeItem('AccountingfirmSwitched');
    }

    this.isAuthenticated = this.authenticationService.isAuthenticated;
    const path = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);
    // Convert searchParams into an array of key-value pairs
    const queryParams: [string, string][] = [];
    searchParams.forEach((value: string, key: string) => {
      queryParams.push([key, value]);
    });

    for (const [key, value] of queryParams) {
      this.queryParams[key] = value;
    }

    this.currentPath = path;
  }

  private initializeAuthenticatedApp(): void {
    if (this.hasInitializedAuthenticatedApp) {
      return;
    }

    this.hasInitializedAuthenticatedApp = true;

    this.InitializeSignalR();

    //window.addEventListener('popstate', this.handlePopState);
  }

  public async InitializeSignalR() {
    const getAccessToken = async () => {
      try {
        // Get token from authentication service (it handles validation and refresh)
        const token = await firstValueFrom(this.authenticationService.getSignalRAccessToken());

        if (!token) {
          return null;
        }

        return token;
      } catch (error) {
        return null;
      }
    };

    const envURl = environment.apiBasePath;
    const hubURL = envURl + '/KCHubs/dashboardHub';
    await fetch("/");

    this.hubConnectionBuilder = new HubConnectionBuilder()
      .withUrl(hubURL, {
        accessTokenFactory: getAccessToken,
        withCredentials: true,  // Include cookies for CORS
        transport: HttpTransportType.WebSockets
          | HttpTransportType.LongPolling
      }).withAutomaticReconnect()
      .build();

    // Handle reconnecting event - validate token before attempting reconnection
    this.hubConnectionBuilder.onreconnecting(async (error) => {
      try {
        if (!this.authenticationService.isAuthenticated) {
          // Stop the connection
          await this.hubConnectionBuilder.stop();
        }
      } catch (error) {
        // Token validation or refresh failed
        console.error('SignalR: Token validation failed during reconnection', error);

        // Stop the connection
        await this.hubConnectionBuilder.stop();
      }
    });

    // Handle reconnected event
    this.hubConnectionBuilder.onreconnected(async (connectionId) => {
      console.log('SignalR: Reconnected successfully. Connection ID:', connectionId);
    });

    this.hubConnectionBuilder
      .start()
      .then(() => {
        console.log('SignalR: Connection started successfully');
      })
      .catch(err => {
        // Check if error is due to authentication
        if (err && (err.statusCode === 401 || err.message?.includes('401') || err.message?.includes('Unauthorized'))) {
          this._toastr.error('Failed to connect: Authentication error', 'Connection Error');
        }
      });

    this.SendDashboardUpdate('SendDashboardUpdate', 'Popup');
    this.SendClearCacheUpdate('SendClearCacheUpdate');
  }

  public SendClearCacheUpdate(hubMethodName: string) {
    this.hubConnectionBuilder.on(hubMethodName, (result: any) => {
      if(result.actionType === SignalRNotification.SignalRActionTypes.UserUpdated) {
        this.referenceDataCache.invalidateUsers();
      } else if(result.actionType === SignalRNotification.SignalRActionTypes.UserRoleUpdated) {
        this.referenceDataCache.invalidateRolesPermissions();
      } else if(result.actionType === SignalRNotification.SignalRActionTypes.TeamRoleUpdated) {
        this.referenceDataCache.invalidateTeamsForCombo();
      } else if(result.actionType === SignalRNotification.SignalRActionTypes.AccountingFirmUpdated) {
        this.referenceDataCache.invalidateFirmDetails();
      }
      this.commonService.hideLoader();
    });
  }


  public SendDashboardUpdate(hubMethodName, msgDisplayType) {
    this.hubConnectionBuilder.on(hubMethodName, (result: any) => {
      if (this.handleClientListExportResult(result)) {
        return;
      }
      if (!this.isSystemIdle) {
        this.dashBoardMessage = true;
        if (msgDisplayType === 'Popup') {
          this.SignalRTitle = result.title;
          this.SignalRMessages = result.message;
          this.SignalRActionType = result.actionType;
          this.SignalRModalPopupOpen(this.SignalRModalPopup);
          this.isMsgFromLoginPage = false;
          this.IsAccountingfirmSwitched = result.actionType === SignalRNotification.SignalRActionTypes.UserAccountingFirmSwitched;
          if (this.IsAccountingfirmSwitched && !this.IsLocalEnvironment) {
            this.blockAllActions(); // Block all application actions
            localStorage.setItem('AccountingfirmSwitched', 'true');
          }
        }
      }
    });
  }

 
  private handleClientListExportResult(result: any): boolean {
    const actionType = result?.actionType;
    if (
      actionType !== SignalRNotification.SignalRActionTypes.ClientListExportReady &&
      actionType !== SignalRNotification.SignalRActionTypes.ClientListExportFailed
    ) {
      return false;
    }

    
    if (this.commonService.activeExportToastId === null) {
      return true;
    }
    this._toastr.remove(this.commonService.activeExportToastId);
    this.commonService.activeExportToastId = null;
    this.commonService.hideLoader(); // hideLoader() is a counter, so it's released here only


    const downloadUrl = typeof result?.message === 'string' ? result.message.trim() : '';
    if (actionType === SignalRNotification.SignalRActionTypes.ClientListExportReady && /^https:\/\//i.test(downloadUrl)) {
      // The SAS URL carries Content-Disposition: attachment, so navigating an anchor downloads it
      // without leaving the page.
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.rel = 'noopener';
      document.body.appendChild(link);
      link.click();
      link.remove();
      this._toastr.success('Client list export downloaded.', 'Export');
    } else {
      this._toastr.error(result?.message || 'Your client list export failed. Please try again.', 'Export');
    }
    return true;
  }

  public SignalRModalPopupOpen(modalPopup) {
    if (!this.IsSignalRPopupOpen) {
      this.modalRef = this.modalService.show(modalPopup, {
        class: 'modal-lg modal-dialog-centered updateModal-popup cmn-modal-dsgn m-auto signalr-critical-modal',
        backdrop: 'static',
        keyboard: false, // Disable ESC key to close
        ignoreBackdropClick: true // Prevent closing on backdrop click
      });
      this.IsSignalRPopupOpen = true;
      this.startSignalRModalAutoCloseTimer();

      // Ensure modal stays on top and focused
      setTimeout(() => {
        this.bringSignalRModalToFront();
      }, 0);
    }
  }

  private bringSignalRModalToFront(): void {
    const signalRModal = document.querySelector('.signalr-critical-modal') as HTMLElement;
    const modalContainers = document.querySelectorAll('.modal') as NodeListOf<HTMLElement>;
    const modalBackdrops = document.querySelectorAll('.modal-backdrop') as NodeListOf<HTMLElement>;

    modalBackdrops.forEach((backdrop, index) => {
      backdrop.style.zIndex = index === modalBackdrops.length - 1 ? '100000' : '1040';
    });

    modalContainers.forEach((modal) => {
      modal.style.zIndex = modal.querySelector('.signalr-critical-modal') ? '100001' : '1050';
    });

    if (signalRModal) {
      signalRModal.style.zIndex = '100002';
    }
  }

  modalpopupClose() {
    this.clearSignalRModalAutoCloseTimer();
    this.commonService.showLoader();
    this.unblockAllActions(); // Unblock all application actions
    this.modalRef?.hide();
    this.IsSignalRPopupOpen = false;

    // Perform logout based on action type
    if (this.isMsgFromLoginPage) {
      this.authenticationService.logout();
    }
    else if (this.SignalRActionType === SignalRNotification.SignalRActionTypes.UserAccountingFirmSwitched && !this.IsLocalEnvironment) {
      this.authenticationService.logout();
    }
    else if (this.SignalRActionType === SignalRNotification.SignalRActionTypes.UserAccountingFirmSwitched && this.IsLocalEnvironment) {
      window.location.reload();
    }
  }

  getSignalRMessageStatements(): string[] {
    if (!this.SignalRMessages) {
      return [];
    }

    return this.SignalRMessages.match(/[^.!?]+[.!?]*/g)
      ?.map(messageStatement => messageStatement.trim())
      .filter(messageStatement => messageStatement.length > 0) || [];
  }

  private startSignalRModalAutoCloseTimer(): void {
    this.clearSignalRModalAutoCloseTimer();
    this.signalRModalAutoCloseTimer = setTimeout(() => {
      if (this.IsSignalRPopupOpen) {
        this.modalpopupClose();
      }
    }, 60000);
  }

  private clearSignalRModalAutoCloseTimer(): void {
    if (this.signalRModalAutoCloseTimer) {
      clearTimeout(this.signalRModalAutoCloseTimer);
      this.signalRModalAutoCloseTimer = null;
    }
  }

  public login(): void {
    this.authenticationService.login();
  }

  public logout(): void {
    this.authenticationService.logout();
  }

  public logoutB2C(): void {
    this.isLoginCompletedSuccessfully = false;
    /* KC logout */

    this.authService.logout()
      .pipe(
        takeUntil(this.unsubscribe),
        finalize(() => {
          /* keyclock logout */
          this.authenticationService.logout();
        })
      )
      .subscribe({
        next: () => { },
        error: () => { }
      });
  }

  b2cLoginTokenHendler() {
    // Developer Rahul Newara Ticket CUSt-967 Date: 29-04-2022
    let origin = this.activatedroute.snapshot.fragment;
    if (origin != null) {
      if (origin.includes('access_denied'))
        this.router.navigate(['/']);
      else {
        if (this.loginEmail != null) {
          this.folderPath = "/kc-Develop/";
          if (this.folderPath == '/kc-Develop/') {
            this.Email = this.loginEmail;
            this.Password = "123456";
            this.InviteAccepted = true;
            this.LoginPost();
          }
        }
      }
    }
  }

  callloginpage() {
    this.authenticationService.logout();
  }

  getTimeZone() {
    const now = new Date();
    const offsetMinutes = now.getTimezoneOffset(); // IST: -330
    const sign = offsetMinutes <= 0 ? '+' : '-';
    const hours = String(Math.floor(Math.abs(offsetMinutes) / 60)).padStart(2, '0');
    const minutes = String(Math.abs(offsetMinutes) % 60).padStart(2, '0');
    const formattedOffset = `UTC${sign}${hours}:${minutes}`;
    this.userTimeZoneLocation = `${formattedOffset}`;

    this.userTimeZone = moment.tz.guess(); // e.g., "Asia/Kolkata"
  }

  LoginPost() {
    this.getTimeZone();
    if (this.Email != "") {
      if (this.Password != "") {
        this.commonService.showLoader();
        const user = { Email: this.Email, Password: this.Password, InviteAccepted: this.InviteAccepted, Offset: this.userTimeZoneLocation, Timezone: this.userTimeZone };

        this.authService.login(user).pipe(takeUntil(this.unsubscribe$)).subscribe({
          next: (result: any) => {
            if (result == 'CasmosDb Issue') {
              this.isLoginCompletedSuccessfully = false;
              this.commonService.hideLoader();
              this.callloginpage();
            } else if (result.status == "Success") {
              // Clear authentication flags after successful login
              this.isLoginCompletedSuccessfully = true;
              this.user = result;
              localStorage.setItem('Dbkey', result.dbc);
              localStorage.setItem('token', this.access_token);
              localStorage.setItem('Userid', result.userId);
              const shortName = this.GetShortName(result.fullName);
              localStorage.setItem('shortName', shortName);
              localStorage.setItem('BackgroundColor', result.backgroundColor);
              localStorage.setItem('TextColor', result.textColor);
              localStorage.setItem('FullName', result.fullName);
              localStorage.setItem('RoleName', result.roleName);
              localStorage.setItem('RoleId', result.roleId);
              localStorage.setItem('AccountFirmId', result.accountingFirmId);
              localStorage.setItem('DMSProviderType', result.dmsProviderType); //SharePoint Developer:  Sandesh
              localStorage.setItem('userMetadataPermission', (result?.isMetadataConfig || false?.toString()));

              this.permissionService.getUserPermissions(result.roleId).subscribe();
              if (result.dmsProviderType != "SharePoint") {
                this.generateDMSToken(this.Email);
              }

              //get url  fi empty/dashboard thyenm navigae to dashboard.otherwise
              this.href = this.currentPath;
              let navigationPromise: Promise<boolean>;
              if (this.href == '/dashboard') {
                navigationPromise = this.router.navigate(['/dashboard']);
              }
              else if (this.href == '/') {
                navigationPromise = this.router.navigate(['/dashboard']);
              }
              else {
                navigationPromise = this.router.navigate([this.currentPath], { queryParams: this.queryParams });
              }
              this.getWidgets();
              this.initializeAuthenticatedApp();
              navigationPromise.finally(() => {
                this.commonService.hideLoader();
              });
            } else if (result.status == "INPR") {
              this.isLoginCompletedSuccessfully = false;
              this.commonService.hideLoader();
            } else if (result.status == "UDEL") {
              this.isLoginCompletedSuccessfully = false;
              this.commonService.hideLoader();
            } else if (result.message == "Incorrect username and password") {
              this.isLoginCompletedSuccessfully = false;
              this.activatedroute.snapshot.fragment = null;
              this.commonService.hideLoader();
              this.ErrorTitle = "Authentication error";
              this.ErrorMessage = result.message;
              this.ErrorModalPopupOpen(this.ErrorModalPopup);
              this.IsErrorPopupOpen = true;
            } else {
              this.isLoginCompletedSuccessfully = false;
              this.commonService.hideLoader();
            }
          },
          error: (err: any) => {
            this.isLoginCompletedSuccessfully = false;
            this.commonService.hideLoader();
            this.ErrorTitle = "Authentication error";
            this.ErrorMessage = err?.detail || 'We are unable to proceed due to a technical issue. Please contact support.';
            this.ErrorModalPopupOpen(this.ErrorModalPopup);
            this.IsErrorPopupOpen = true;
          }
        });
      } else {
        this.isLoginCompletedSuccessfully = false;
        this.commonService.hideLoader();
      }
    } else {
      this.isLoginCompletedSuccessfully = false;
      this.commonService.hideLoader();
    }
  }

  public ErrorModalPopupOpen(modalPopup) {
    if (!this.IsErrorPopupOpen) {
      this.modalRef = this.modalService.show(modalPopup, {
        class: 'modal-lg modal-dialog-centered updateModal-popup cmn-modal-dsgn m-auto signalr-critical-modal',
        backdrop: 'static',
        keyboard: false, // Disable ESC key to close
        ignoreBackdropClick: true // Prevent closing on backdrop click
      });

      // Ensure modal stays on top and focused
      setTimeout(() => {
        const modalElement = document.querySelector('.signalr-critical-modal');
        if (modalElement) {
          (modalElement as HTMLElement).style.zIndex = '100000';
        }
      }, 0);
    }
  }

  errormodalpopupClose() {
    this.commonService.showLoader();
    this.unblockAllActions(); // Unblock all application actions
    this.modalRef?.hide();
    this.IsErrorPopupOpen = false;
    this.ErrorMessage = ''; // Clear error message

    this.authenticationService.logout();
  }

  // private handlePopState = (event: PopStateEvent) => {
  //     // Close modal
  //     this.modalRef?.hide();
  //     this.IsErrorPopupOpen = false;

  //     // Logout immediately
  //     this.authenticationService.logout();
  // };

  private blockAllActions() {
    // Disable all pointer events on the body except for the modal
    document.body.style.pointerEvents = 'none';

    // Enable pointer events only on modal
    setTimeout(() => {
      const modalElements = document.querySelectorAll('.signalr-critical-modal, .signalr-critical-modal *');
      modalElements.forEach((element: any) => {
        element.style.pointerEvents = 'auto';
      });

      // Ensure blocking overlay is in place
      const overlay = document.querySelector('.signalr-blocking-overlay');
      if (overlay) {
        (overlay as HTMLElement).style.pointerEvents = 'none';
      }
    }, 100);

    // Block keyboard shortcuts
    this.blockKeyboardShortcuts();

    // Push a dummy state to block back button
    if (!this.isNavigationBlocked) {
      window.history.pushState(null, '', window.location.href);
      this.isNavigationBlocked = true;
    }

    // Prevent right-click context menu
    document.addEventListener('contextmenu', this.preventContextMenu, true);
  }

  private unblockAllActions() {
    // Re-enable pointer events
    document.body.style.pointerEvents = 'auto';

    // Unblock keyboard shortcuts
    this.unblockKeyboardShortcuts();

    // Re-enable right-click context menu
    document.removeEventListener('contextmenu', this.preventContextMenu, true);

    this.isNavigationBlocked = false;
  }

  private preventContextMenu = (event: MouseEvent) => {
    event.preventDefault();

    // Set localStorage flag as a safety net
    localStorage.setItem('AccountingfirmSwitched', 'true');

    // Close modal
    this.modalRef?.hide();
    this.IsErrorPopupOpen = false;

    // Logout immediately
    this.authenticationService.logout();

    return false;
  };

  private blockKeyboardShortcuts() {
    document.addEventListener('keydown', this.preventKeyboardActions, true);
  }

  private unblockKeyboardShortcuts() {
    document.removeEventListener('keydown', this.preventKeyboardActions, true);
  }

  private preventKeyboardActions = (event: KeyboardEvent) => {
    let shouldLogout = false;

    // Block F5 (refresh)
    if (event.key === 'F5') {
      event.preventDefault();
      event.stopPropagation();
      shouldLogout = true;
    }

    // Block Ctrl+R (refresh)
    if ((event.ctrlKey || event.metaKey) && event.key === 'r') {
      event.preventDefault();
      event.stopPropagation();
      shouldLogout = true;
    }

    // Block Ctrl+W (close tab)
    if ((event.ctrlKey || event.metaKey) && event.key === 'w') {
      event.preventDefault();
      event.stopPropagation();
      shouldLogout = true;
    }

    // Block Alt+Left Arrow (back)
    if (event.altKey && event.key === 'ArrowLeft') {
      event.preventDefault();
      event.stopPropagation();
      shouldLogout = true;
    }

    // Block Alt+Right Arrow (forward)
    if (event.altKey && event.key === 'ArrowRight') {
      event.preventDefault();
      event.stopPropagation();
      shouldLogout = true;
    }

    // Block Backspace (in case it's used for navigation)
    if (event.key === 'Backspace' && (event.target as HTMLElement).tagName !== 'INPUT' && (event.target as HTMLElement).tagName !== 'TEXTAREA') {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }

    // If any navigation key was pressed, logout the user
    if (shouldLogout) {
      // Close modal
      this.modalRef?.hide();
      this.IsErrorPopupOpen = false;

      // Logout immediately
      this.authenticationService.logout();

      return false;
    }
  };

  GetShortName(FirstName) {
    let shortName = "KC";
    if ((FirstName != "" || FirstName != undefined)) {
      let tempnameparts = FirstName.split(" ");
      let nameparts = tempnameparts.filter((x) => x);  // Dev: Prabhakar K; Cust - 3133  26/10/2023
      if (nameparts.length > 0) {
        shortName = (nameparts[0].charAt(0) + nameparts[1].charAt(0)).toUpperCase();
      }
    }
    return shortName == '' ? "KC" : shortName; // Dev: Prabhakar K; Cust - 3133  26/10/2023
  }

  getUserPermissions(roleId) {
    this.accountService.getAccountPermissions(roleId).subscribe(result => {
      this.userdata = result;
      localStorage.setItem('UserPermissions', JSON.stringify(result));
    },
      error => {
        this._toastr.error('Something went wrong at User Permission at Login');
      });
  }

  generateDMSToken(email: string): void {
    this.authService.getDMSToken(email).pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (res: any) => {
        localStorage.setItem('DMS_Token', res.bearerToken);
      },
      error: (error: any) => {
        /* Need to catch the error and display a toaster here in future */
      }
    });
  }

  loadBrainfishWidget(widgetKey: string): void {
    const userId = localStorage.getItem('Userid') || '';
    const email = localStorage.getItem('Email') || '';
    const teamId = localStorage.getItem('AccountFirmId') || '';

    const script = document.createElement('script');
    script.type = 'module';
    script.text = `
      import Brainfish from "https://cdn.jsdelivr.net/npm/@brainfish-ai/web-widget@latest/dist/web.js";

      Brainfish.Widgets.init({
        widgetKey: "${widgetKey}",
      });

      Brainfish.Widgets.identify({
        userId: "${userId}",
        email: "${email}",
        properties: {
          teamId: "${teamId}",
          subscription: "premium",
          isAdmin: true,
        },
      });
    `;
    document.body.appendChild(script);
  }

  getWidgets() {
    this.xeroService.getSupportWidgetKey().subscribe({
      next: (widgetKey: string) => {
        this.loadBrainfishWidget(widgetKey);
      },
      error: (err) => {
      }
    });
  }

  ngOnDestroy(): void {
    //window.removeEventListener('popstate', this.handlePopState);  
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.sub.unsubscribe();
    document.body.classList.remove(this.appLoaderActiveClass);
    this.clearSignalRModalAutoCloseTimer();
  }

}
